// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YXnj","title":"styles_title__3XM2k"};